import React from "react";
import * as ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { conf } from "./utils";
// import ReactPixel from 'react-facebook-pixel';
import Adjust from "@adjustcom/adjust-web-sdk";

const app = document.getElementById("root");
app.classList.add("notranslate");
app.setAttribute("notranslate", "true");
ReactDOM.render(<App />, app);

conf();
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);
// We listen to the resize event
window.addEventListener("resize", () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
});
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// const PIXEL_FACEBOOK_KEY = {
//   TRADEMAP: '532810507459348',
//   CARTEIRA_DO_MILHAO: '636030253668760',
//   INVESTIDOR_ATIVO: '704247826797499'
// }

// const options = {
//   autoConfig: true, 	// set pixel's autoConfig
//   debug: false, 		// enable logs
// };

// ReactPixel.init(PIXEL_FACEBOOK_KEY.TRADEMAP, {}, options);
// ReactPixel.init(PIXEL_FACEBOOK_KEY.INVESTIDOR_ATIVO, {}, options);
// ReactPixel.init(PIXEL_FACEBOOK_KEY.CARTEIRA_DO_MILHAO, {}, options);
// ReactPixel.pageView();

export function triggerAdjustEvent(eventCode, investorId) {
	try {
		Adjust.trackEvent({
			eventToken: eventCode,
			callbackParams: [{ key: "idInvestor", value: investorId }],
		});
	} catch (err) {
		console.error(err);
	}
}
